const CookieManager = require('./src/cookie-manager');

module.exports = CookieManager;
